/**
 * Escapes `<` and `>` characters that a person typed as comparison operators, so the browser does
 * not read them as the start of a tag.
 *
 * Legacy v1 quote descriptions were plain text. People wrote things like `Walls <8 feet` and
 * `Walls >8 feet`. Rendered as HTML, `<8` opens a tag and swallows the text after it, so both
 * forms have to become entities first.
 *
 * Only brackets that sit directly against a number are escaped, and the `>` form must also follow
 * whitespace or start the string. That second anchor matters: an earlier version excluded only
 * letters and `"` before the `>`, which matched the digit at the end of an `h1`–`h6` tag name.
 * `<h3>25+ years` then became `<h3&gt;25+ years`, and because `&gt;` holds no `>` character,
 * `striptags` treated the rest of the string as one malformed tag and dropped the whole field
 * (#23082). Whitespace never precedes the `>` of a real tag, so the anchor cannot repeat that.
 *
 * A bare `>` left in text content is valid HTML and renders as `>`, so declining to escape it is
 * safe.
 *
 * Known limit, carried over unchanged from the code this replaced: the `<` rule fires anywhere a
 * `<` sits against a number, including inside an attribute value. `alt="<100% coverage"` becomes
 * `alt="&lt;100% coverage"`. The escape is correct for display in that example, but the rule reads
 * no markup structure, so it cannot tell an attribute from text. Fixing that needs a parser, not a
 * regex.
 */
export function escapeStrayAngleBrackets(html: string): string {
  if (!html) {
    return html
  }

  return html.replace(/<(\d+)/g, '&lt;$1').replace(/(^|\s)>(\d+)/g, '$1&gt;$2')
}
